"use strict";

exports.__esModule = true;
exports.default = void 0;

var renderGroup = function renderGroup() {// noop
};

var _default = renderGroup;
exports.default = _default;